import { useSelector } from "react-redux";
import { selectCurrentToken } from "./authSlice";
import { Link } from "react-router-dom";
import { ColorModeContext, useMode } from "../../theme";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import { Routes, Route } from 'react-router-dom';

import Topbar from "../../components/react-dashboard/global/Topbar";
import Sidebar from "../../components/react-dashboard/global/Sidebar";
import Dashboard from "../../components/react-dashboard/dashboard";
import Users from "../../components/react-dashboard/users";
import OrganizationForm from "../../components/react-dashboard/org_form";
import Organizations from "../../components/react-dashboard/organizations";
import Organization from "../../components/react-dashboard/organization";
import UserForm from "../../components/react-dashboard/user_form";
import User from "../../components/react-dashboard/user";
import UserEditForm from "../../components/react-dashboard/edit_user";
import OrganizationEditForm from "../../components/react-dashboard/edit_org";
import ManageStorageIntegrations from '../../components/react-dashboard/storage_integrations';
import MonitorRealTimeResources from "../../components/react-dashboard/monitor_rt_resources";
import ManageS3Access from "../../components/react-dashboard/s3_access";
import IntegrationDetail from '../../components/react-dashboard/integration_detail';
import MediaADC from "../../components/react-dashboard/media_adc";
import MarketPulse from "../../components/react-dashboard/market_pulse";
import DataAssetManagement from "../../components/react-dashboard/data_assets";
import DataAssetForm from "../../components/react-dashboard/new_data_asset";
import DevBlog from '../../components/react-dashboard/dev_blog';
import S3Onboarding from "../../components/react-dashboard/s3_onboarding";
import Ldc from "../../components/react-dashboard/ldc";
import DeliveryMatrix from "../../components/react-dashboard/delivery_matrix";
import DataQa from "../../components/react-dashboard/data_qa";
import CompanyModelQa from "../../components/react-dashboard/data_qa/company_model/CompanyModelQa";
import ResetPassword from "../../components/react-dashboard/user_actions/ResetPassword";
import AdminDashboard from "../../components/react-dashboard/admin";
import MediaAPIs from "../../components/react-dashboard/media_apis";
import { DiscreteModeProvider } from "../../components/react-dashboard/global/DiscreteMode";



import RequireAuth from "./RequireAuth";

const Console = () => {
  const [theme, colorMode] = useMode();

  

  return (
    <DiscreteModeProvider>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Box display="flex" width="100%" height="100vh">
            <Sidebar />
            <Box component="main" width="100%" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
              <Topbar />
              <Box width="100%" sx={{ flexGrow: 1, p: 2 }}>
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/users/*" element={<Users />} />
                    <Route path="/users/:username" element={<User />} />
                    <Route path="/users/:username/edit" element={<UserEditForm />} />
                    <Route path="/organizations/*" element={<Organizations />} />
                    <Route path="/organization/:organization_id" element={<Organization />} />
                    <Route path="/organization/:organization_id/edit" element={<OrganizationEditForm />} />
                    <Route path="/organization/:organization_id/users/new" element={<UserForm />} />
                    <Route path="/organization/:organization_id/s3_onboarding" element={<S3Onboarding />} />
                    <Route path="/organizations/new" element={<OrganizationForm />} />
                    <Route path="/users/new" element={<UserForm />} />
                    <Route path="/storage-integrations/:integrationName" element={<IntegrationDetail />} />
                    <Route path="/monitor-real-time-resources" element={<MonitorRealTimeResources />} />
                    <Route path="/manage-storage-integrations" element={<ManageStorageIntegrations />} />
                    <Route path="/manage-s3-access" element={<ManageS3Access />} />
                    <Route path="/media-adc" element={<MediaADC />} />
                    <Route path="/media-apis" element={<MediaAPIs />} />
                    <Route path="/market-pulse" element={<MarketPulse />} />
                    <Route path="/data" element={<DataAssetManagement />} />
                    <Route path="/data/new" element={<DataAssetForm />} />
                    <Route path="/dev-blog" element={<DevBlog />} />
                    <Route path="/delivery-matrix" element={<DeliveryMatrix />} />
                    <Route path="/ldc" element={<Ldc />} />
                    <Route path="/data-qa" element={<DataQa />} />
                    <Route path="/data-qa/company-model" element={<CompanyModelQa />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
              </Box>
            </Box>
          </Box>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </DiscreteModeProvider>
  );
};

export default Console;
